import React from "react";
import { Helmet } from "react-helmet"; // ✅ Import Helmet
import { Briefcase, Code, Smartphone, TrendingUp, ArrowRight} from "lucide-react"; // example icons

const HowWeHelp =() =>{
    return(
        <section className="how-we-help">
            {/* ✅ SEO Meta Tags */}
            {/* <Helmet>
                <title>How We Help | Pravisht Digital</title>
                <meta name="description" content="Discover how Pravisht empowers businesses through intelligent software engineering, digital platforms, and user-focused innovation." />
                <meta name="keywords" content="Pravisht, Software Engineering, Digital Platforms, Innovation, Tech Solutions, User Experience" />
                <meta property="og:title" content="How We Help | Pravisht Digital" />
                <meta property="og:description" content="We help transform ideas into scalable digital solutions—designed for performance, growth, and innovation." />
                <meta property="og:type" content="website" />
                <meta name="author" content="Pravisht Digital" />
            </Helmet> */}
            <div className="how-we-help-header">
                <div className="how-we-help__content">
                    <h1 className="how-we-help__title">Empowering Your Business for Growth</h1>
                    <hr className="portfolio-horizontalline"></hr>
                    <p className="how-we-help__description">
                    We help you transform ideas into powerful digital solutions—driving growth through innovation, seamless user experiences, and reliable technology.
                    </p>
                </div>
            </div>
            <div className="how-we-help__cards">
                {[
                     { icon: <Briefcase size={40} />, title: "Intelligent Software Engineering", desc: "Smart, scalable systems built for performance." },
                     { icon: <Code size={40} />, title: "Next-Gen Digital Platforms", desc: "Future-ready platforms with modern tech." },
                    { icon: <Smartphone size={40} />, title: "Adaptive Tech Solutions", desc: "Flexible solutions for evolving needs." },
                    { icon: <TrendingUp size={40} />, title: "Human-Centered Innovation", desc: "Tech that’s intuitive and user-first." }
        
                ].map((card, i) => (
                <div className="how-we-help__card" key={i}>
                    <div className="card-icon">{card.icon}</div>
                    <h3 className="card-title">{card.title}</h3>
                    <p className="card-desc">{card.desc}</p>
                    <div className="card-arrow">
                        {/* <ArrowRight size={40} /> */}→
                    </div>
                </div>
                ))}
            </div>
        </section>
    );
};

export default HowWeHelp;
